// Selectors


import { RootState } from '../../store';

export const toastMessageSelector = (state: RootState) => state.toastMessageState
